/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CompanyRes } from '../models/company-res';
import { MtDepartmentQueryReq } from '../models/mt-department-query-req';
import { MtDepartmentReq } from '../models/mt-department-req';
import { MtDepartmentRes } from '../models/mt-department-res';

@Injectable({
  providedIn: 'root',
})
export class MasterDataDepartmentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiMasterdataDepartmentGet
   */
  static readonly ApiMasterdataDepartmentGetPath = '/api/masterdata/department';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterdataDepartmentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterdataDepartmentGet$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<MtDepartmentRes>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataDepartmentService.ApiMasterdataDepartmentGetPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MtDepartmentRes>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMasterdataDepartmentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterdataDepartmentGet(params?: {
    id?: number;
  }): Observable<MtDepartmentRes> {

    return this.apiMasterdataDepartmentGet$Response(params).pipe(
      map((r: StrictHttpResponse<MtDepartmentRes>) => r.body as MtDepartmentRes)
    );
  }

  /**
   * Path part for operation apiMasterdataDepartmentPut
   */
  static readonly ApiMasterdataDepartmentPutPath = '/api/masterdata/department';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterdataDepartmentPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterdataDepartmentPut$Response(params?: {
    id?: number;
    body?: MtDepartmentReq
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataDepartmentService.ApiMasterdataDepartmentPutPath, 'put');
    if (params) {
      rb.query('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMasterdataDepartmentPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterdataDepartmentPut(params?: {
    id?: number;
    body?: MtDepartmentReq
  }): Observable<void> {

    return this.apiMasterdataDepartmentPut$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiMasterdataDepartmentPost
   */
  static readonly ApiMasterdataDepartmentPostPath = '/api/masterdata/department';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterdataDepartmentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterdataDepartmentPost$Response(params?: {
    body?: MtDepartmentReq
  }): Observable<StrictHttpResponse<MtDepartmentRes>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataDepartmentService.ApiMasterdataDepartmentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MtDepartmentRes>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMasterdataDepartmentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterdataDepartmentPost(params?: {
    body?: MtDepartmentReq
  }): Observable<MtDepartmentRes> {

    return this.apiMasterdataDepartmentPost$Response(params).pipe(
      map((r: StrictHttpResponse<MtDepartmentRes>) => r.body as MtDepartmentRes)
    );
  }

  /**
   * Path part for operation apiMasterdataDepartmentDelete
   */
  static readonly ApiMasterdataDepartmentDeletePath = '/api/masterdata/department';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterdataDepartmentDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterdataDepartmentDelete$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataDepartmentService.ApiMasterdataDepartmentDeletePath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMasterdataDepartmentDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterdataDepartmentDelete(params?: {
    id?: number;
  }): Observable<void> {

    return this.apiMasterdataDepartmentDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiMasterdataDepartmentQueryPost
   */
  static readonly ApiMasterdataDepartmentQueryPostPath = '/api/masterdata/department/query';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterdataDepartmentQueryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterdataDepartmentQueryPost$Response(params?: {
    body?: MtDepartmentQueryReq
  }): Observable<StrictHttpResponse<Array<MtDepartmentRes>>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataDepartmentService.ApiMasterdataDepartmentQueryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MtDepartmentRes>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMasterdataDepartmentQueryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterdataDepartmentQueryPost(params?: {
    body?: MtDepartmentQueryReq
  }): Observable<Array<MtDepartmentRes>> {

    return this.apiMasterdataDepartmentQueryPost$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MtDepartmentRes>>) => r.body as Array<MtDepartmentRes>)
    );
  }

  /**
   * Path part for operation apiMasterdataDepartmentOptCompaniesGet
   */
  static readonly ApiMasterdataDepartmentOptCompaniesGetPath = '/api/masterdata/department/opt/companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterdataDepartmentOptCompaniesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterdataDepartmentOptCompaniesGet$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CompanyRes>>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataDepartmentService.ApiMasterdataDepartmentOptCompaniesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CompanyRes>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMasterdataDepartmentOptCompaniesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterdataDepartmentOptCompaniesGet(params?: {
  }): Observable<Array<CompanyRes>> {

    return this.apiMasterdataDepartmentOptCompaniesGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CompanyRes>>) => r.body as Array<CompanyRes>)
    );
  }

}
